export const environment = {
  KAPS_V1_DIRECT_URL: "https://kaps-sales-dev.syion.net/",
  KAPS_API_BACKEND_URL: "https://kaps-sales-dev.syion.net/Services/",
  KAPS_V1_HOME_URL: "https://kaps-sales-dev.syion.net/Home.aspx#/",
  API_TIMEOUT: 30000,
};
